import React from "react";
import { useTranslation } from "react-i18next";
import MarketingLayout from "./components/MarketingLayout.js";
import MarketingFooterCtas from "./components/MarketingFooterCtas.js";

export default function Overview() {
  const { t } = useTranslation();

  const capabilities = [
    { kicker: "01", title: t("overview_cap_1") },
    { kicker: "02", title: t("overview_cap_2") },
    { kicker: "03", title: t("overview_cap_3") },
    { kicker: "04", title: t("overview_cap_4") },
    { kicker: "05", title: t("overview_cap_5") },
  ];

  return (
    <MarketingLayout>
      <div className="marketing-page-content overview-page">
        <header className="marketing-page-intro">
          <p className="marketing-page-eyebrow">Product</p>
          <h1>{t("overview_title")}</h1>
          <p className="page-lead">{t("overview_subtitle")}</p>
        </header>

        <section className="marketing-section-card">
          <h2 className="marketing-section-title">{t("overview_what_is")}</h2>
          <p className="marketing-section-text">{t("overview_what_is_desc")}</p>
        </section>

        <h2 className="marketing-section-title" style={{ marginBottom: "1rem" }}>
          {t("overview_key_capabilities")}
        </h2>
        <div className="marketing-capability-grid">
          {capabilities.map((item) => (
            <section key={item.kicker} className="marketing-section-card">
              <span className="marketing-kicker" aria-hidden>
                {item.kicker}
              </span>
              <p className="marketing-section-text">{item.title}</p>
            </section>
          ))}
        </div>

        <section className="marketing-section-card">
          <h2 className="marketing-section-title">{t("overview_who_for")}</h2>
          <p className="marketing-section-text">{t("overview_who_for_desc")}</p>
        </section>

        <MarketingFooterCtas />
      </div>
    </MarketingLayout>
  );
}
